module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-primary box-solid"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-4"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.rank),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Rank:',
      "name": 'rank',
      "messages": {
        required: 'This field is required'
      }
    },
    model: {
      value: (_vm.role.rank),
      callback: function($$v) {
        _vm.$set(_vm.role, "rank", $$v)
      },
      expression: "role.rank"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.name),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Name:',
      "name": 'name',
      "messages": {
        required: 'This field is required'
      }
    },
    model: {
      value: (_vm.role.name),
      callback: function($$v) {
        _vm.$set(_vm.role, "name", $$v)
      },
      expression: "role.name"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.description),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Description:',
      "name": 'description'
    },
    model: {
      value: (_vm.role.description),
      callback: function($$v) {
        _vm.$set(_vm.role, "description", $$v)
      },
      expression: "role.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [(_vm.$route.params && !_vm.$route.params._id) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$valid)
    },
    on: {
      "click": _vm.createRole
    }
  }, [_vm._v("Create Role")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [(_vm.$route.params && _vm.$route.params._id) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.updateRole
    }
  }, [_vm._v("Update Role")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "permissions"
    }
  }, [(!_vm.loading) ? _c('role-permissions', {
    attrs: {
      "role": _vm.role
    }
  }) : _vm._e()], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#details"
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#permissions"
    }
  }, [_vm._v("Permissions")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7e584023", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e584023"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/roles/RoleCreate.vue
// module id = 2359
// module chunks = 0